import { redirectToHomeIfNoRangesAccess } from '@/ranges/router/guards';
import { redirectToProfileIfNotAdminOrTeamlead } from '@/settings/router/guards';

const RangesPage = () => import('@/ranges/pages/ranges.vue');
const RangesSettingsAccessPage = () => import('@/ranges/pages/settings/access.vue');
const RangesSettingsColumnsPage = () => import('@/ranges/pages/settings/columns.vue');
const RangesSettingsPage = () => import('@/ranges/pages/ranges-settings.vue');
const LayoutRanges = () => import('@/ranges/layouts/layout-ranges.vue');

export const rangesRoutes = [
  {
    path: '',
    component: LayoutRanges,
    children: [
      {
        path: '/ranges',
        name: 'ranges',
        component: RangesPage,
        beforeEnter: redirectToHomeIfNoRangesAccess,
      },
      {
        path: '/ranges/settings',
        name: 'ranges-settings',
        redirect: { name: 'ranges-settings-access' },
        component: RangesSettingsPage,
        beforeEnter: redirectToProfileIfNotAdminOrTeamlead,
        children: [
          {
            path: 'access',
            name: 'ranges-settings-access',
            component: RangesSettingsAccessPage,
          },
          {
            path: 'columns',
            name: 'ranges-settings-columns',
            component: RangesSettingsColumnsPage,
          },
        ],
      },
    ],
  },
];
